import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
import { GiftIcon, HeadphonesIcon, ClipboardCheckIcon, BookOpenIcon } from 'lucide-react';
export function BonusStackSection() {
  const bonuses = [{
    num: '01',
    icon: <HeadphonesIcon className="w-6 h-6 text-gold-500" data-id="element-96" />,
    title: 'Audio Guía de Inducción',
    desc: 'Sesión de relajación progresiva diseñada para voces maduras.',
    value: '$17 USD'
  }, {
    num: '02',
    icon: <ClipboardCheckIcon className="w-6 h-6 text-gold-500" data-id="element-97" />,
    title: 'Checklist del Dormitorio Perfecto',
    desc: 'Configura tu habitación para favorecer el sueño profundo.',
    value: '$9 USD'
  }, {
    num: '03',
    icon: <BookOpenIcon className="w-6 h-6 text-gold-500" data-id="element-98" />,
    title: 'Diario de Sueño de 7 Días',
    desc: 'Registra tu progreso y observa la transformación.',
    value: '$12 USD'
  }];
  return <section id="bonos" className="py-20 md:py-24 bg-[#0d1527] border-t border-white/10 scroll-mt-8" data-id="element-99">
      <div className="max-w-5xl mx-auto px-6" data-id="element-100">
        <FadeIn data-id="element-101">
          <div className="text-center mb-14" data-id="element-102">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full card-glass mb-6" data-id="element-103">
              <GiftIcon className="w-4 h-4 text-gold-400" data-id="element-104" />
              <span className="text-sm uppercase tracking-widest text-gold-400 font-medium" data-id="element-105">
                Bonos Incluidos
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-serif mb-4 text-glow" data-id="element-106">
              Más 3 bonos para que duermas mejor desde la primera noche
            </h2>
            <p className="text-cream-muted text-body-lg max-w-2xl mx-auto" data-id="element-107">
              Todo lo que necesitas para construir tus mejores noches, sin
              esfuerzo.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-108">
          {bonuses.map((b, i) => <FadeIn key={i} delay={0.1 + i * 0.1} data-id="element-109">
              <div className="card-glass rounded-md p-7 h-full flex flex-col" data-id="element-110">
                <div className="flex items-center justify-between mb-5" data-id="element-111">
                  <span className="text-sm font-medium tracking-widest text-gold-400" data-id="element-112">
                    BONUS #{b.num}
                  </span>
                  {b.icon}
                </div>
                <h3 className="text-xl font-serif text-white mb-3" data-id="element-113">
                  {b.title}
                </h3>
                <p className="text-cream-muted text-base mb-6 flex-grow" data-id="element-114">
                  {b.desc}
                </p>
                <div className="pt-5 border-t border-white/15" data-id="element-115">
                  <span className="text-sm text-cream-muted" data-id="element-116">Valor: </span>
                  <span className="text-gold-400 font-medium" data-id="element-117">{b.value}</span>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-118">
          <div className="card-glass rounded-md p-8 max-w-2xl mx-auto text-center" style={{
          borderColor: 'rgba(201,168,76,0.4)'
        }} data-id="element-119">
            <div className="flex flex-col sm:flex-row items-center justify-around gap-6" data-id="element-120">
              <div data-id="element-121">
                <p className="text-sm text-cream-muted uppercase tracking-wider mb-2" data-id="element-122">
                  Valor Total
                </p>
                <p className="text-3xl font-serif text-cream-muted line-through decoration-gold-500/60" data-id="element-123">
                  $65 USD
                </p>
              </div>
              <div className="hidden sm:block w-px h-16 bg-white/20" data-id="element-124"></div>
              <div data-id="element-125">
                <p className="text-sm text-gold-400 uppercase tracking-wider mb-2" data-id="element-126">
                  Tu Precio Hoy
                </p>
                <p className="text-4xl font-serif text-gold-400" data-id="element-127">$27 USD</p>
              </div>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-128">
          <div id="quiero-bonos" className="mt-12 text-center scroll-mt-24" data-id="element-129">
            <Button href="#oferta" className="px-10 py-5 text-lg" data-id="element-130">
              Quiero Mis Bonos Ahora
            </Button>
            <p className="mt-4 text-sm text-cream-muted" data-id="element-131">
              Reserva tu acceso y todos los bonos al precio de lanzamiento.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}